import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { getColumnName } from '../../service/column';

import LoadingComponent from '../LoadingComponent';
import MdArrowDropUp from 'react-icons/lib/md/arrow-drop-up';
import MdArrowDropDown from 'react-icons/lib/md/arrow-drop-down';

import css from '../../styles/table/flextable';

class FlexTable extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        columns: PropTypes.array,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        expectedHeight: PropTypes.number,
        onSortClick: PropTypes.func,
        filters: PropTypes.object,
        t: PropTypes.func.isRequired,
    }

    renderHeadings() {
        const rows = [];
        const { t } = this.props;

        // FlexTable IS sortable
        if (typeof this.props.onSortClick === 'function') {
            const { sort } = this.props.filters;

            for (const column of this.props.columns) {
                const className = [css.tableHead];
                const label = t(getColumnName(column));

                // @TODO add column name as class by default
                if (label.indexOf(t('change')) > -1) {
                    className.push(css.change);
                }
                if (label.indexOf(t('share')) > -1) {
                    className.push(css.sharePercent);
                }

                let chevron;
                if (sort.column === column) {
                    className.push(css.sortedBy);

                    if (sort.direction === 'ASC') {
                        chevron = (<MdArrowDropUp className={css.sortIcon} />);
                    } else {
                        chevron = (<MdArrowDropDown className={css.sortIcon} />);
                    }
                }

                rows.push(
                  <div
                      className={className.join(' ')}
                      onClick={() => this.props.onSortClick(column)}
                      key={label}
                  >
                      {label}{chevron}
                  </div>
                );
            }

            return rows;
        }

        // FlexTable is NOT sortable
        for (const column of this.props.columns) {
            const className = [css.tableHead];
            const label = t(getColumnName(column));
            if (label.indexOf(t('change')) > -1) {
                className.push(css.change);
            }
            if (label.indexOf(t('share')) > -1) {
                className.push(css.sharePercent);
            }

            rows.push(<div className={className.join(' ')} key={label}>{label}</div>);
        }

        return rows;
    }

    renderChildren() {
        const { children, expectedHeight } = this.props;

        if (!children.length && expectedHeight) {
            return <LoadingComponent height={expectedHeight} />;
        }

        return children;
    }

    render() {
        let classNames;

        if (this.props.className) {
            if (Array.isArray(this.props.className)) {
                classNames = this.props.className;
                classNames.push(css.table);
            } else {
                classNames = [css.table, this.props.className];
            }
        } else {
            classNames = [css.table];
        }

        return (
            <div className={classNames.join(' ')} data-columns={this.props.columns.length}>
                <div className={css.tableHeader}>
                    {this.renderHeadings()}
                </div>
                <div>
                    {this.renderChildren()}
                </div>
            </div>
        );
    }
}

export default translate('common')(FlexTable);



/** WEBPACK FOOTER **
 ** /src/shared/components/table/FlexTable.js
 **/